export default "__VITE_ASSET__BtAGxnLJ__"